

  
  $(".bundle_add_to_cart").on("click",async function(){
   
    var array_product = [];
    var properties_check = $(".ProductBundler").find(".ProductBundler__Item").html();
    var total_qty = 0;
    var max_qty = 0;
    $(".bundle_variant_group .bundle_var_qty").each(function(){
      var var_id = $(this).data("var_id");
      var qty = parseInt($(this).val());
      var var_product_id = $(this).data("product_id");
      if(qty > 0)
       { 
        if($(this).hasClass("byo_bundle"))
        { 
          if(!$(this).hasClass("main_bundle_qty"))
           { 
             max_qty = parseInt($(this).attr("max"));
             total_qty += parseInt(qty);
           }
        }
        
        array_product.push({qty:qty, id:var_id, product_id: var_product_id});
      }
    });
    
    
      if(total_qty < max_qty)
      { 
        alert("Please select "+max_qty+" Quantity");
        return false;
      }
      else if(max_qty == 0)
      {
        alert("Please select product Quantity");
        return false;
      }

    
    array_product = array_product.reverse();
    if(array_product.length == 0)
    {
      alert("Please select quantity of bundle products");
    }
  
  });

  $(".bundle_var_qty").on("change", function(){
    var total_qty = 0;
    var max_qty = parseInt($(this).attr("max"));
    if(parseInt($(this).val()) > max_qty)
    {
      $(this).val(0);
      alert("You can select maximum "+max_qty+" products");
      return false;
    }
    
    $(".bundle_variant_group .bundle_var_qty").each(function(){
      if(!$(this).hasClass("main_bundle_qty"))
      {
       total_qty += parseInt($(this).val());
      }
    });
    
    if(total_qty > max_qty)
    {
     var rmaining_qty = max_qty - (total_qty - parseInt($(this).val()));
      
     if(rmaining_qty < 0)
     {
      rmaining_qty = 0;
     }
      
     $(this).val(rmaining_qty);
     alert("You can select maximum "+max_qty+" products");
     return false;
      
    }
  });
  
  
